export const PERMISSION_CONSTANT = {
  // dashboard
  VIEW_RS_DASHBOARD: "view-rs-dashboard",
  VIEW_RIDER_CURRENT_ORDERS: "view-rider-current-orders",
  // overview
  CREATE_ORDER_DISPATCHER_NOTES: "create-order-dispatcher-notes",
  VIEW_ORDERS: "view-orders",
    VIEW_ORDER_MANUAL_ASSIGN: "view-order-manual-assign", // force order manual assign
    VIEW_ORDER_UN_ASSIGN: "view-order-un-assign", // force order manual assign
    VIEW_ORDER_FORCE_RE_ASSIGN: "view-order-force-re-assign", // force re assign
    VIEW_ORDER_COMPLETE: "view-order-complete", // force order complete
    VIEW_ORDER_CANCEL: "view-order-cancel", // force order complete
    VIEW_ORDER_INITIAL_COMPLETE: "view-order-initial-complete", // force order initial complete
    VIEW_ORDER_INITIAL_CANCEL: "view-order-initial-cancel", // force order initial complete
    VIEW_ORDER_DISPATCHER_NOTES: "view-order-dispatcher-notes", // dispatcher notes
    VIEW_RETURN_PICKUP_ORDER: "view-return-pickup-order", //view return pickup order
    VIEW_CUSTOMER_ADDRESS: "view-customer-address",
    VIEW_Rider_PHONE: "view-rider-phone",
    VIEW_ORDER_UNFREEZE: "view-order-unfreeze", // order unfreeze toggle
    VIEW_CHARGE_TO_RIDER: "view-charge-to-rider", // order unfreeze toggle
  // batch  
  VIEW_BATCH: "view-batch",
  VIEW_BATCH_RIDERS: "view-batch-riders",
  VIEW_DEFAULT_CONFIG: "view-default-config",
  VIEW_WALLET_STACKING: "view-wallet-stacking",
  // zones
  CREATE_ZONES: "create-zones",
  EDIT_ZONES: "edit-zones",
  VIEW_ZONES: "view-zones",
  // riders
  CREATE_RIDERS: "create-riders",
  VIEW_RIDER_APPROVE: "view-rider-approve",
  VIEW_RIDER_BREAK: "view-rider-break",
  VIEW_RIDER_ASSIGN_BATCH: "view-rider-assign-batch",
  VIEW_RIDER_BLOCK: "view-rider-block",
  VIEW_RIDER_UNBLOCK: "view-rider-unblock",
  VIEW_RIDER_SUSPEND: "view-rider-suspend",
  VIEW_RIDER_ACTIVE: "view-rider-active",
  VIEW_RIDER_TOOKAN_SYNC: "view-rider-tookan-sync",
  VIEW_RIDER_SYNC_TO_RMS: "view-rider-sync-to-rms",
  EDIT_RIDERS: "edit-riders",
  VIEW_RIDERS: "view-riders",
    VIEW_FORCE_FREE_RIDER: "view-force-free-rider",
    VIEW_RIDER_ZONES_ASSIGNMENT: "view-rider-zones-assignment",
    VIEW_RIDER_SUSPENSION_CSV_BULK: "view-csv-rider-suspend-bulk",
    VIEW_RE_UPLOAD_PROFILE_IMAGE: "view-re-upload-profile-image",
  // VIEW_RIDER_LIVE_LOCATION_MAP: "view-rider-live-location-map",
  // shifts
  CREATE_SHIFTS: "create-shifts",
  EDIT_SHIFTS: "edit-shifts",
  VIEW_SHIFT_UPLOAD_CSV: "view-shift-upload-csv",
  VIEW_SHIFTS: "view-shifts",
    VIEW_SHIFT_ACTIVE: "view-shift-active",
    VIEW_SHIFT_INACTIVE: "view-shift-inactive",
    VIEW_SHIFT_REMOVE_RIDER: "view-shift-remove-rider",
    VIEW_SHIFT_REASSIGN_RIDER: "view-shift-reassign-rider",
  // break
  VIEW_BREAK: "view-break",
    VIEW_END_BREAK: "view-end-break",
  // notification
  VIEW_NOTIFICATION: "view-notification",
  // Rider live location dashboard
  VIEW_RIDER_LOCATION: "view-rider-location",
  // cancelled orders dashboard
  VIEW_CANCELLED_ORDERS_DASHBOARD: "view-cancelled-orders-dashboard",
    VIEW_CANCELLED_ORDERS_DASHBOARD_RECEIVE: "view-cancelled-orders-dashboard-receive",
    VIEW_CANCELLED_ORDERS_DASHBOARD_FORCE_RECEIVE: "view-cancelled-orders-dashboard-force-receive",
  // issues
  VIEW_OPEN_ISSUES: "view-open-issues",
  VIEW_PICKED_OPEN_ISSUES: "view-picked-open-issues",
  VIEW_MY_OPEN_ISSUES: "view-my-open-issues",
  VIEW_ISSUES_HISTORY: "view-issues-history",
  VIEW_MARK_COMPLETE: "view-mark-complete",
  VIEW_PICK_ISSUE: "view-pick-issue",
  // performance dashboard
  VIEW_PERFORMANCE_KPI_DASHBOARD: "view-performance-kpi-dashboard",
  // pickerpacker
  VIEW_PICKER_PACKER: "view-picker-packer",
  CREATE_PICKER_PACKER: "create-picker-packer",
  EDIT_PICKER_PACKER: "edit-picker-packer",
  // site config
  VIEW_SITE_CONFIG_DASHBOARD: "view-site-config-dashboard",
  // Triggers
  VIEW_TRIGGERS: "view-triggers",
  EDIT_TRIGGERS: "edit-triggers",
  // Works
  VIEW_WORK: "view-work",
  VIEW_RELEASE_WORK: "view-release-work",
  VIEW_ACTUAL_INVOICE_QTY: "view-actual-invoice-qty",
  VIEW_WORK_APPROVAL_BUTTON: "view-work-approval-button",
  VIEW_ALLOW_SHORT_PICK: "view-allow-short-pick",
  VIEW_PICTURE_PACKED_TIME: "view-picture-packed-time",
  //CMS
  VIEW_RIDER_TERMS_AND_CONDITIONS: "view-rider-terms-and-conditions",
}